/* tslint:disable */
/* eslint-disable */
/**
 * Brokers API
 * API for managing brokers
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BrokerDto } from './BrokerDto';
import {
    BrokerDtoFromJSON,
    BrokerDtoFromJSONTyped,
    BrokerDtoToJSON,
    BrokerDtoToJSONTyped,
} from './BrokerDto';

/**
 * 
 * @export
 * @interface GetBrokerListResponse
 */
export interface GetBrokerListResponse {
    /**
     * 
     * @type {number}
     * @memberof GetBrokerListResponse
     */
    totalCount: number;
    /**
     * 
     * @type {Array<BrokerDto>}
     * @memberof GetBrokerListResponse
     */
    items: Array<BrokerDto>;
}

/**
 * Check if a given object implements the GetBrokerListResponse interface.
 */
export function instanceOfGetBrokerListResponse(value: object): value is GetBrokerListResponse {
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function GetBrokerListResponseFromJSON(json: any): GetBrokerListResponse {
    return GetBrokerListResponseFromJSONTyped(json, false);
}

export function GetBrokerListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBrokerListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'],
        'items': ((json['items'] as Array<any>).map(BrokerDtoFromJSON)),
    };
}

export function GetBrokerListResponseToJSON(json: any): GetBrokerListResponse {
    return GetBrokerListResponseToJSONTyped(json, false);
}

export function GetBrokerListResponseToJSONTyped(value?: GetBrokerListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalCount': value['totalCount'],
        'items': ((value['items'] as Array<any>).map(BrokerDtoToJSON)),
    };
}

